<template>
  <button @click="exportPlanOrder" class="btn btn-primary mr-1">
    <i class="fa fa-download"></i>
    {{ $t('export') }}
    <b-modal v-model="exporting" :title="$t('exportingData')" @close="close" no-close-on-esc no-close-on-backdrop no-enforce-focus>
      <div class="alert alert-warning">
        <span>{{ $t('exportNotice') }}</span>
      </div>
      <div class="text-center">
        <b-spinner></b-spinner>
      </div>
    </b-modal>
  </button>
</template>

<script>
import {saveAs} from 'file-saver';
import Excel from 'exceljs';

export default {
  props: ['data', 'sum', "avg", "label"],
  data() {
    return {
      exporting: false,
      cancelRequest: false,
      downloadedCount: 0
    }
  },
  methods: {
    exportPlanOrder: async function () {
      this.downloadedCount = 0;
      this.exporting = true;
      let workbook = new Excel.Workbook();
      let sheet = workbook.addWorksheet('data');
      this.setupSheet(sheet);
      if (this.sum) {
        let row = this.sum;
        row.label = this.$t('total');
        sheet.addRow(row);
      }
      if (this.avg) {
        let row = this.avg;
        row.label = this.$t('average');
        sheet.addRow(row);
      }
      this.data.forEach(item => {
          let row = item;
          row.label = this.label(item);
          sheet.addRow(row);
          this.downloadedCount += 1;
        });

      workbook.xlsx.writeBuffer({base64: true}).then(data => {
        this.exporting = false;
        saveAs(new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
            'finance-report.xlsx');
      }).finally(() => {
        this.cancelRequest = false;
        this.downloadedCount = 0;
      });
    },
    setupSheet: function (sheet) {
      sheet.columns = [
        {header: '', key: 'label', width: 15},
        {header: this.$t('deposit'), key: 'deposit', width: 15},
        {header: this.$t('gift'), key: 'gift', width: 15},
        {header: this.$t('affiliate'), key: 'affiliate', width: 15},
        {header: this.$t('claim'), key: 'claim', width: 15},
        {header: this.$t('receive'), key: 'receive', width: 15},
        {header: this.$t('call'), key: 'call', width: 15},
        {header: this.$t('callPackage'), key: 'callPackage', width: 15},
        {header: this.$t('cdp'), key: 'cdp', width: 15},
        {header: this.$t('invoicePlanOrder'), key: 'invoicePlanOrder', width: 15},
        {header: 'Email', key: 'email', width: 15},
        {header: 'SMS', key: 'sms', width: 15},
        {header: 'ZNS', key: 'zns', width: 15},
        {header: this.$t('aiChatbot'), key: 'aiChatbot', width: 15},
        {header: 'Speech to text', key: 'callTranscript', width: 15},
        {header: this.$t('financeAiAgentToken'), key: 'aiAgentToken', width: 15},
        {header: 'Gói AI Token tháng', key: 'aiAgentPackage', width: 18},
        {header: this.$t('financeConvEval'), key: 'conversationEval', width: 15},
        {header: 'Viber', key: 'viber', width: 15},
        {header: this.$t('sendOAMessage'), key: 'oa', width: 15},
        {header: 'Line', key: 'linePackage', width: 15},
        {header: this.$t('ccuPackage'), key: 'ccuPackage', width: 15},
        {header: this.$t('number'), key: 'number', width: 15},
        {header: this.$t('setup'), key: 'setup', width: 15},
        {header: this.$t('brandName'), key: 'brandName', width: 15},
        {header: this.$t('brandNameRegister'), key: 'brandNameRegister', width: 15},
        {header: this.$t('new'), key: 'new', width: 15},
        {header: this.$t('newDivide'), key: 'newDivide', width: 15},
        {header: this.$t('upgrade'), key: 'upgrade', width: 15},
        {header: this.$t('extend'), key: 'extend', width: 15},
        {header: this.$t('user'), key: 'user', width: 15},
        // {header: this.$t('flex'), key: 'flex', width: 15},
        {header: this.$t('refund'), key: 'refund', width: 15},
        {header: this.$t('callRefund'), key: 'callRefund', width: 15},
        {header: this.$t('smsRefund'), key: 'smsRefund', width: 15},
        {header: this.$t('send'), key: 'send', width: 15},
        {header: this.$t('financeOther'), key: 'other', width: 15},
        {header: this.$t('totalExpense'), key: 'expense', width: 15},
      ];
    },
    close() {
      this.cancelRequest = true;
    }
  },
  i18n: {
    messages: {
      vi: {
        deposit: 'Nạp',
        gift: 'Tặng',
        claim: 'Bồi thường',
        receive: 'Nhận từ client khác',
        call: 'Cước gọi',
        callPackage: 'Cước gọi theo gói',
        number: 'Thuê số',
        setup: 'Cài đặt số',
        brandName: 'Duy trì brand name',
        brandNameRegister: 'Đăng ký brand name',
        new: 'Mua mới dịch vụ',
        newDivide: 'Mua mới do tách domain',
        upgrade: 'Nâng cấp',
        extend: 'Gia hạn',
        user: 'Mua thêm người dùng',
        flex: 'Sử dụng gói flex',
        refund: 'Hoàn lệnh nạp tiền',
        callRefund: 'Hoàn tiền cước gọi',
        smsRefund: 'Hoàn tiền SMS',
        send: 'Chuyển cho client khác',
        totalExpense: 'Tổng tiêu',
        cdp: "Gói CDP",
        affiliate: "Giới thiệu",
        sendOAMessage: "Gửi tin OA",
        ccuPackage: "Gọi video nội bộ",
        aiChatbot: "Nhân viên AI",
        financeAiAgentToken: "Token AI Agent",
        financeConvEval: "AI đánh giá hội thoại",
        financeOther: "Khác",
        invoicePlanOrder: "Dịch vụ hoá đơn điện tử",
      },
      en: {
        deposit: 'Deposit',
        gift: 'Gift',
        claim: 'Claim',
        receive: 'Receive from other client',
        call: 'Call fee',
        callPackage: 'Package call fee',
        number: 'Phone number rental fee',
        setup: 'Phone number setup fee',
        brandName: 'Brand name monthly fee',
        brandNameRegister: 'Brand name register fee',
        new: 'Buy new',
        newDivide: 'Buy new due to dividing',
        upgrade: 'Upgrade',
        extend: 'Extend',
        user: 'Additional user',
        flex: 'Flex fee',
        refund: 'Refund a deposit order',
        callRefund: 'Refund of call charges',
        smsRefund: 'SMS refund',
        send: 'Send money to other client',
        totalExpense: 'Total expense',
        cdp: "CDP package",
        affiliate: "Affiliate",
        sendOAMessage: "Send OA message",
        ccuPackage: "Internal video calling",
        aiChatbot: "AI employee",
        financeAiAgentToken: "AI Agent tokens",
        financeConvEval: "AI conversation eval",
        financeOther: "Other",
        invoicePlanOrder: "Electronic invoice service",
      },
    }
  }
}
</script>
